import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { ListingType } from '#/types/ListingType';
import { showModal } from '#/zustand-stores/modalStore';

type Props = {
  listingId: string;
  listingType: ListingType;
  listingUrl: Record<string, string>;
  orgId: string | null;
};

export function ShareMenuItem({
  listingId,
  listingType,
  listingUrl,
  orgId,
}: Props) {
  const { i18n } = useI18n();

  if (listingType !== 'ORG' && !orgId) {
    return null;
  }

  return (
    <Button
      qaId="share-button"
      onClick={() => {
        showModal('SHARE_LISTING', {
          listingId,
          listingType,
          listingUrl,
        });
      }}
      variant="tertiary-grey"
      iconPosition="left"
      icon={{ type: 'normalized', name: 'share' }}
      size="small"
      type="button"
    >
      {i18n('Share')}
    </Button>
  );
}
